import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator,
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAPuJcIK9hQyK-2I-RDvrh_O30X19Za0WY",
  authDomain: "tradehive-3c2e2.firebaseapp.com",
  projectId: "tradehive-3c2e2",
  storageBucket: "tradehive-3c2e2.firebasestorage.app",
  messagingSenderId: "1093981789910",
  appId: "1:1093981789910:web:8d909fa9ef963ec319f377",
  measurementId: "G-ZVYQZR4RDR"
};

// Optional, isolated local development; production always uses the config above.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === "true";
if (useEmulators) Object.assign(firebaseConfig, {
  apiKey: "demo-api-key", authDomain: "localhost", projectId: "demo-klang-ui",
  storageBucket: "demo-klang-ui.appspot.com", appId: "demo-klang-ui",
});

// ป้องกัน initialize ซ้ำ
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth      = getAuth(app);
// เปิด local cache (IndexedDB) — อ่านข้อมูลที่เคยเห็นแล้วได้ทันทีจากเครื่อง ไม่ต้องรอเน็ตทุกครั้ง
// ของจริงจาก server จะ sync ทับมาอัตโนมัติผ่าน onSnapshot อยู่แล้ว ลดอาการ "บางทีเร็วบางทีช้า"
export const db         = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage   = getStorage(app);
export const functions = getFunctions(app, "asia-southeast1");
if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

// FCM — สร้าง messaging เฉพาะเมื่อ browser รองรับ (Safari เก่าไม่รองรับ)
let messaging = null;
if (!useEmulators) isSupported().then((ok) => {
  if (ok) messaging = getMessaging(app);
}).catch(() => {});
export { messaging };

export default app;
